import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import Layout from "../components/sidebarPro";
import Footer from "../components/footer/Footer";
import Head from "next/head";
import VerifyPhone from "../components/login/VerifyPhone";
import useTranslation from 'next-translate/useTranslation';

var ValidatePhoneNumber = function ValidatePhoneNumber() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var isRTL = lang === 'farsi';
  return /*#__PURE__*/_jsxs(Layout, {
    children: [/*#__PURE__*/_jsxs(Head, {
      children: [/*#__PURE__*/_jsx("title", {
        children: isRTL ? "بررسی شماره تلفن - دنیای واژه ها" : "Verify Phone Number - wow kanoon"
      }), /*#__PURE__*/_jsx("link", {
        rel: "icon",
        href: "/images/logos/favicon.png"
      })]
    }), /*#__PURE__*/_jsx(VerifyPhone, {}), /*#__PURE__*/_jsx(Footer, {})]
  });
};

export var __N_SSG = true;
export default ValidatePhoneNumber;